import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=f4a9d684&scoped=true&"
import script from "./DetailsTable.vue?vue&type=script&lang=ts&"
export * from "./DetailsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=f4a9d684&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a9d684",
  null
  
)

export default component.exports